import { rem } from 'polished';
import styled from '../../../styles/theme';
import { OfferStyled } from '../OfferStyled';

export const OfferStyledDS = styled(OfferStyled)`
    .offer {
        /* override jsStyle */
        max-width: 100%;
        width: 100%;
        svg {
            width: ${rem(16)} !important;
            height: ${rem(16)} !important;
            path,
            rect {
                stroke: ${({ theme }) => theme.colors.champagne2} !important;
            }
        }
    }
`;
